//
// client-exceptions-trend-chart.js
//
// Copyright (c) 2015 by Curalate, Inc.
//


/* eslint no-underscore-dangle: ["error", { "allow": ["_1", "_2"]  }] */

((() => {
    angular.module('curalate').directive('clientExceptionsTrendChart', ['ClientExceptionsService', ClientExceptionsService => ({
        restrict: 'E',

        scope: {
            title: '@',
            config: '=',
            metrics: '=',
        },

        template: '<div><highchart config="chartConfig"></highchart></div>',

        controller: ['$scope', $scope => {
            Highcharts.setOptions({
                global: {
                    useUTC: false,
                },
            });

            $scope.chartConfig = {
                series: [],
                loading: false,
                title: '',
                options: {
                    chart: {
                        backgroundColor: null,
                        borderWidth: 0,
                        type: 'area',
                        margin: [2, 0, 2, 0],
                        width: 120,
                        height: 20,
                        style: {
                            overflow: 'visible',
                        },
                        skipClone: true,
                    },
                    title: {
                        text: '',
                    },
                    credits: {
                        enabled: false,
                    },
                    xAxis: {
                        labels: {
                            enabled: false,
                        },
                        title: {
                            text: null,
                        },
                        type: 'datetime',
                        startOnTick: false,
                        endOnTick: false,
                        tickPositions: [],
                    },
                    yAxis: {
                        endOnTick: false,
                        startOnTick: false,
                        labels: {
                            enabled: false,
                        },
                        title: {
                            text: null,
                        },
                        tickPositions: [0],
                    },
                    legend: {
                        enabled: false,
                    },
                    tooltip: {
                        backgroundColor: '#ffffff',
                        borderWidth: 0,
                        shadow: true,
                        useHTML: true,
                        hideDelay: 0,
                        shared: true,
                        padding: 0,
                        positioner(w, h, point) {
                            return { x: point.plotX - w / 2, y: point.plotY - h - 20 };
                        },
                    },
                    plotOptions: {
                        series: {
                            animation: false,
                            lineWidth: 1,
                            shadow: false,
                            states: {
                                hover: {
                                    lineWidth: 1,
                                },
                            },
                            marker: {
                                radius: 1,
                                states: {
                                    hover: {
                                        radius: 2,
                                    },
                                },
                            },
                            fillOpacity: 0.25,
                        },
                        column: {
                            negativeColor: '#910000',
                            borderColor: 'silver',
                        },
                    },
                },
            };

            const addSeries = metricData => {
                $scope.chartConfig.series.push(
                    {
                        data: metricData,
                        tooltip: {
                            pointFormat: '<b>{point.y}</b>',
                        },
                    }
                    );
            };

            $scope.$watchCollection('metrics', (newValue, oldValue) => {
                if (newValue.length > 1) {
                    addSeries(_.map(newValue, data => [data._1, data._2]));
                }
            });
        }],
    })]);
}))();
